<template>
  <div class="flex flex-wrap gap-4 mt-6 mb-12">
    <div class="bg-white w-[99%] m-auto shadow-ts1 rounded-lg pb-8">
      <div class="px-6 py-5 border-b border-gray-400 flex justify-between items-center">
        <h2 class="font-display text-xl font-bold text-blue leading-none">{{ $t('economic_calendar').tTitle() }}</h2>
        <a target="_blank" :href="`${websiteURL}tools/economic-calendar/`" class="w-28 py-0.5 table text-black font-medium text-center text-sm">{{ $t('learn_more').tTitle() }} </a>
      </div>
      <div class="w-full border-b border-gray-300 px-4 md:px-8 pt-5 pb-4 flex flex-col lg:flex-row justify-between items-start lg:items-center">
        <iframe id="tradingcentral" :src="iframeURL" allowfullscreen="true" frameborder="0" scrolling="yes" width="100%" class="min-h-[2500px] h-full" height="2500"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { service } from '@/main.js'
import { mapGetters, mapActions } from 'vuex'
import config from '../../config'

export default {
  data() {
    return {
      iframeURL: '',
      websiteURL: config.URL.website,
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      logoLoaderActive: 'logoLoader/active',
    }),
  },
  beforeMount() {},
  mounted() {
    this.getIframeURL()
  },
  watch: {},
  created() {},
  methods: {
    getIframeURL() {
      // this['logoLoader/set'](true)
      service
        .post('/tradingcentral/handshake', {
          user: this.User.info.ID.toString(),
          page: 'economic_calendar',
        })
        .then(response => {
          // this['logoLoader/set'](false)
          this.iframeURL = response.data
        })
        .catch(error => {
          // this['logoLoader/set'](false)
          console.log(error)
          this.$toasted.error(this.$t('something_went_wrong'))
        })
    },
    ...mapActions(['logoLoader/set']),
  },
}
</script>
